import { createFileRoute } from "@tanstack/react-router";

import { AdminUserDetails } from "@/features/user/components/AdminUserDetails";

export const Route = createFileRoute("/_admin/admin/users/$userId/")({
  component: AdminUserDetailsPage,
});

function AdminUserDetailsPage() {
  const { userId } = Route.useParams();

  return (
    <div className="p-2 pt-4 md:pt-8 md:p-8 bg-gray-100">
      <AdminUserDetails userId={userId} context="page" />
    </div>
  );
}
